import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SnackbarService } from "src/app/core/service/snackbar.service";
import { ApiCoursesService } from "src/app/data/service/courses/api-courses.service";
import { GraphicData } from "../../schema/graphic-data";
import { GraphicDetail } from "../../schema/graphic-detail";

@Component({
    selector: "app-graphic-details",
    templateUrl: "./graphic-details.component.html",
    styleUrls: ["./graphic-details.component.scss"]
})
export class GraphicDetailsComponent implements OnInit {
    @Input("data")
    public data: GraphicData;

    @Input("export_data")
    public exportData: boolean;

    public details: GraphicDetail[];
    public columnDefinitions: string[];

    constructor(
        private translate: TranslateService,
        private snackBar: SnackbarService,
        private coursesService: ApiCoursesService
    ) {
        this.details = [];
        this.columnDefinitions = [];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data && JSON.stringify(changes.data.previousValue) != JSON.stringify(changes.data.currentValue)) {
            this.manageData(changes.data.currentValue);
        }
    }

    ngOnInit() {
        this.manageData(this.data);
    }

    private manageData(data: GraphicData) {
        this.details = [];
        this.columnDefinitions = [];

        if (data == undefined) return;

        if (data.keys.length <= 0) return;

        this.translate.get("GRAPHIC_REPORT.DESCRIPTION").subscribe((res) => {
            data.group.forEach((group) => {
                data.keys.forEach((key, index) => {
                    const temp: GraphicDetail = {};

                    temp["Position"] = index + 1;
                    temp[res] = group.group;

                    temp[key] = group.values[index];

                    this.details.push(temp);

                    if (this.columnDefinitions.length <= 0)
                        this.columnDefinitions = Object.getOwnPropertyNames(temp).filter((x) => x !== "Position");
                });
            });
        });
    }

    public requestDataExport = (): void => {
        this.coursesService.requestReport().subscribe(
            () => {
                this.translate.get("GRAPHIC_REPORT.MESSAGES.EXPORT_SUCCESS").subscribe((res) => {
                    this.snackBar.showMessage(res);
                });
            },
            () => {
                this.translate.get("GRAPHIC_REPORT.MESSAGES.EXPORT_FAILURE").subscribe((res) => {
                    this.snackBar.showMessage(res);
                });
            }
        );
    };
}
